var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.101 355.6h307.798l21.411-96.346A15 15 0 0 0 416.668 241H95.333a14.997 14.997 0 0 0-14.642 18.254zM256 298.3c8.28 0 15 6.721 15 15s-6.72 15-15 15-15-6.721-15-15 6.72-15 15-15z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 103.9,
    r: 71.767,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.134 175.667h-64.268c-29.848 0-56.531 13.792-74.024 35.333h212.316c-17.493-21.541-44.177-35.333-74.024-35.333zM497 385.6H15c-8.284 0-15 6.716-15 15v64.267c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V400.6c0-8.284-6.716-15-15-15z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.02a33f29d6ce53854f3036c60f861e09.svg";
export { ForwardRef as ReactComponent };